import type { ReactNode } from 'react'
import * as Mtds from '@mattilsynet/design/react'
import type { ScreenHeaderProperty } from '../screen-header/ScreenHeader'

type DetailsCardProps = {
  title: string
  properties?: ScreenHeaderProperty[]
  icon?: ReactNode
  defaultOpen?: boolean
  children?: ReactNode
}

const PropertyValue = ({ property }: { property: ScreenHeaderProperty }) => {
  const content = property.value ?? '-'

  if (property.href != null) return <a href={property.href}>{content}</a>

  return content
}

export const DetailsCard = ({
  title,
  properties = [],
  icon,
  defaultOpen = true,
  children
}: DetailsCardProps) => {
  if (!properties.length && !children) return null

  return (
    <Mtds.Details data-variant='card' open={defaultOpen}>
      <Mtds.Details.Summary>
        {icon}
        {title}
      </Mtds.Details.Summary>
      <Mtds.Grid data-gap='4'>
        {properties.map((property) => (
          <Mtds.Info
            key={property.label}
            data-tooltip={property.tooltip}
            className='grid grid-cols-[minmax(0,7.5rem)_minmax(0,1fr)] items-center gap-[var(--mtds-4)]'
          >
            <strong className='min-w-0 font-normal'>{property.label}</strong>
            <span className='min-w-0'>
              <PropertyValue property={property} />
            </span>
          </Mtds.Info>
        ))}
        {children}
      </Mtds.Grid>
    </Mtds.Details>
  )
}
